import React from 'react';

import Box from '../common/Box/Box';
import Upload from '../common/Upload/Upload';
import withUpload from '../common/HOC/with-upload/WithUpload';

import { TestID } from '../../testID';

import type { Pipe } from 'src/types/pipes.types';

import './PipeInput.css';

const EntityUpload = withUpload()(Upload);

export const UploadEntities: React.FC<{ pipe: Pipe; subUrl: string; token: string }> = ({
  pipe,
  subUrl,
  token,
}) => (
  <div data-testid={TestID.PipeInputUploadEntities} className="pipe-input">
    <div className="pipe-input__description">
      <h1 className="heading-page">Upload entities</h1>
      <p className="output-">
        {`This pipe gets its entities from the `}
        <code>{`/receivers/${pipe['_id']}/entities`}</code>
        {` endpoint.
        You can use the upload form below to push entities to the pipe.`}
      </p>
    </div>
    <div className="pipe-input__content">
      <div className="pipe-input__content-section">
        {/* @ts-ignore */}
        <Box>
          <Box.Header>
            <Box.Title>Upload</Box.Title>
          </Box.Header>
          {/* @ts-ignore */}
          <Box.Content padding>
            <EntityUpload
              url={`${subUrl}/receivers/${encodeURIComponent(pipe._id)}/entities`}
              token={token}
              allowed={['json']}
              editor
              curl
            />
          </Box.Content>
        </Box>
      </div>
    </div>
  </div>
);
